/* Best Sellers: separate navigation for the horizontal product row on mobile.
   The swipe inside each product image remains independent. */
(() => {
  const setup = () => {
    document.querySelectorAll('.section--media-with-collection').forEach((section) => {
      const heading = section.querySelector('h2');
      if (!heading || heading.textContent.trim() !== 'Best Sellers') return;

      const row = section.querySelector('.media-with-collection__products.swipe-mobile');
      const host = row && row.closest('media-with-collection');
      if (!host || host.querySelector('.yc-carousel-nav')) return;

      section.classList.add('yc-best-sellers');
      const headerLink = section.querySelector('.section__header a');
      if (headerLink) {
        headerLink.style.setProperty('background', 'transparent', 'important');
        headerLink.style.setProperty('color', '#34291f', 'important');
        headerLink.style.setProperty('border', '1px solid #34291f', 'important');
        headerLink.style.setProperty('box-shadow', 'none', 'important');
      }
      const nav = document.createElement('div');
      nav.className = 'yc-carousel-nav';
      nav.setAttribute('aria-label', 'Browse more products');
      nav.innerHTML = '<button type="button" class="yc-carousel-nav__button" aria-label="Previous product">&#8249;</button><div class="yc-carousel-nav__track" aria-hidden="true"><span class="yc-carousel-nav__thumb"></span></div><button type="button" class="yc-carousel-nav__button" aria-label="Next product">&#8250;</button>';
      host.append(nav);
      nav.style.cssText = 'align-items:center;gap:14px;width:min(72vw,320px);margin:20px auto 0';
      nav.querySelectorAll('button').forEach((button) => { button.style.cssText = 'flex:0 0 32px;width:32px;height:32px;padding:0;border:0;background:transparent;color:#27211d;font-size:25px;line-height:1;cursor:pointer'; });
      nav.querySelector('.yc-carousel-nav__track').style.cssText = 'position:relative;flex:1;height:3px;border-radius:3px;background:rgba(39,33,29,.16);overflow:hidden';
      nav.querySelector('.yc-carousel-nav__thumb').style.cssText = 'display:block;height:100%;width:var(--yc-thumb-width,20%);border-radius:3px;background:#27211d;transform:translateX(var(--yc-thumb-x,0px))';

      const [previous, next] = nav.querySelectorAll('button');
      const track = nav.querySelector('.yc-carousel-nav__track');
      const thumb = nav.querySelector('.yc-carousel-nav__thumb');

      const update = () => {
        const info = row.querySelector('.product-card__info');
        if (info && window.innerWidth < 768) {
          const top = info.getBoundingClientRect().top - host.getBoundingClientRect().top;
          host.style.setProperty('--yc-nav-top', `${top}px`);
        }
        nav.style.display = window.innerWidth < 768 ? 'flex' : 'none';
        const max = Math.max(0, row.scrollWidth - row.clientWidth);
        const width = track.clientWidth;
        const thumbWidth = max ? Math.max(24, width * row.clientWidth / row.scrollWidth) : width;
        const fraction = max ? Math.min(1, Math.max(0, row.scrollLeft / max)) : 0;
        thumb.style.setProperty('--yc-thumb-width', `${thumbWidth}px`);
        thumb.style.setProperty('--yc-thumb-x', `${fraction * (width - thumbWidth)}px`);
        previous.disabled = max <= 2;
        next.disabled = max <= 2;
      };

      const move = (direction) => {
        const slides = row.querySelectorAll('.swiper-slide');
        const step = slides.length > 1 ? slides[1].offsetLeft - slides[0].offsetLeft : row.clientWidth * 0.72;
        const max = Math.max(0, row.scrollWidth - row.clientWidth);
        const wraps = direction > 0 ? row.scrollLeft >= max - step / 2 : row.scrollLeft <= step / 2;
        const target = wraps ? (direction > 0 ? 0 : max) : Math.min(max, Math.max(0, row.scrollLeft + step * direction));
        row.scrollTo({ left: target, behavior: wraps ? 'auto' : 'smooth' });
      };
      previous.addEventListener('click', () => move(-1));
      next.addEventListener('click', () => move(1));
      row.addEventListener('scroll', update, { passive: true });
      window.addEventListener('resize', update);
      requestAnimationFrame(update);
    });
  };

  if (document.readyState === 'loading') {
    document.addEventListener('DOMContentLoaded', setup, { once: true });
  } else {
    setup();
  }
  document.addEventListener('shopify:section:load', setup);
  (() => {
    const initArrows = () => document.querySelectorAll('.yc-best-sellers').forEach(section => {
      const row = section.querySelector('.media-with-collection__products.swipe-mobile');
      if (!row || section.dataset.ycArrowReady) return;
      section.dataset.ycArrowReady = 'true';
      if (!document.getElementById('yc-bs-arrows-style')) {
        const style = document.createElement('style');
        style.id = 'yc-bs-arrows-style';
        style.textContent = '@media(max-width:767.98px){.yc-best-sellers{position:relative;padding-block-end:1.6rem!important}.yc-best-sellers .yc-carousel-nav,.yc-best-sellers .yc-best-sellers__hint{display:none!important}.yc-best-sellers.yc-best-sellers media-with-collection{padding-bottom:0!important}.yc-bs-product-arrows{position:absolute;left:-15px;right:-15px;z-index:8;pointer-events:none;display:flex;justify-content:space-between;transform:translateY(-50%)}.yc-bs-product-arrows button{pointer-events:auto;width:42px;height:48px;border:0;background:transparent;color:rgba(42,34,29,.68);font-size:0;display:grid;place-items:center;cursor:pointer}.yc-bs-product-arrows button::before{content:"";width:10px;height:10px;border-top:2px solid currentColor;border-right:2px solid currentColor;transform:rotate(225deg)}.yc-bs-product-arrows button:last-child::before{transform:rotate(45deg)}.yc-bs-product-arrows button:focus-visible,.yc-bs-photo-arrow:focus-visible{outline:2px solid #2a221d;outline-offset:2px}.yc-best-sellers .product-card__image-wrapper{position:relative}.yc-bs-photo-arrow{position:absolute;top:50%;z-index:8;transform:translateY(-50%);width:32px;height:40px;border:0;border-radius:999px;background:rgba(255,255,255,.5);color:rgba(42,34,29,.72);font-size:23px;line-height:1;cursor:pointer}.yc-bs-photo-arrow--prev{left:5px}.yc-bs-photo-arrow--next{right:5px}}@media(min-width:768px){.yc-bs-product-arrows,.yc-bs-photo-arrow{display:none!important}}';
        document.head.append(style);
      }
      const arrows = document.createElement('div');
      arrows.className = 'yc-bs-product-arrows';
      arrows.innerHTML = '<button type="button" aria-label="Previous product">&#8249;</button><button type="button" aria-label="Next product">&#8250;</button>';
      section.append(arrows);
      const position = () => {
        const info = row.querySelector('.product-card__info');
        if (info) arrows.style.top = (info.getBoundingClientRect().top - section.getBoundingClientRect().top + info.offsetHeight / 2) + 'px';
      };
      requestAnimationFrame(() => requestAnimationFrame(position));
      window.addEventListener('resize', position);
      window.addEventListener('load', position, { once: true });
      const move = direction => {
        const slides = row.querySelectorAll('.swiper-slide');
        const step = slides.length > 1 ? slides[1].offsetLeft - slides[0].offsetLeft : row.clientWidth * .72;
        const max = Math.max(0, row.scrollWidth - row.clientWidth);
        const wraps = direction > 0 ? row.scrollLeft >= max - step / 2 : row.scrollLeft <= step / 2;
        row.scrollTo({ left: wraps ? (direction > 0 ? 0 : max) : Math.min(max, Math.max(0, row.scrollLeft + step * direction)), behavior: wraps ? 'auto' : 'smooth' });
      };
      const buttons = arrows.querySelectorAll('button');
      buttons[0].addEventListener('click', () => move(-1));
      buttons[1].addEventListener('click', () => move(1));
      let touch = null;
      row.addEventListener('touchstart', event => {
        if (!event.target.closest('.product-card__info')) return;
        const point = event.touches[0];
        touch = { x: point.clientX, y: point.clientY, left: row.scrollLeft, max: Math.max(0, row.scrollWidth - row.clientWidth) };
      }, { passive: true });
      row.addEventListener('touchend', event => {
        if (!touch) return;
        const point = event.changedTouches[0], dx = point.clientX - touch.x, dy = point.clientY - touch.y, start = touch;
        touch = null;
        if (Math.abs(dx) < 35 || Math.abs(dx) <= Math.abs(dy) * 1.2) return;
        if (dx < 0 && start.left >= start.max - 3) row.scrollTo({ left: 0, behavior: 'auto' });
        if (dx > 0 && start.left <= 3) row.scrollTo({ left: start.max, behavior: 'auto' });
      }, { passive: true });
      row.querySelectorAll('.product-card__image-wrapper').forEach(image => {
        const track = image.querySelector('[data-mobile-product-card-slider]');
        if (!track || track.querySelectorAll('.product-card__image--mobile-slide').length < 2) return;
        [-1, 1].forEach(direction => {
          const button = document.createElement('button');
          button.type = 'button';
          button.className = 'yc-bs-photo-arrow yc-bs-photo-arrow--' + (direction < 0 ? 'prev' : 'next');
          button.setAttribute('aria-label', direction < 0 ? 'Previous photo' : 'Next photo');
          button.innerHTML = direction < 0 ? '&#8249;' : '&#8250;';
          button.addEventListener('click', event => {
            event.preventDefault(); event.stopPropagation();
            const count = track.querySelectorAll('.product-card__image--mobile-slide').length;
            const index = Math.round(track.scrollLeft / track.clientWidth);
            track.scrollTo({ left: ((index + direction + count) % count) * track.clientWidth, behavior: 'smooth' });
          });
          image.append(button);
        });
      });
    });
    if (document.readyState === 'loading') document.addEventListener('DOMContentLoaded', initArrows, { once: true });
    else initArrows();
    document.addEventListener('shopify:section:load', () => requestAnimationFrame(initArrows));
  })();
  const enhance = () => document.querySelectorAll('.yc-best-sellers').forEach(section => {
    const row = section.querySelector('.media-with-collection__products.swipe-mobile');
    const nav = section.querySelector('.yc-carousel-nav');
    if (!row || !nav || nav.dataset.gestureReady) return;
    nav.dataset.gestureReady = 'true';
    if (!document.getElementById('yc-bs-gesture-style')) {
      const style = document.createElement('style');
      style.id = 'yc-bs-gesture-style';
      style.textContent = '@media(max-width:767.98px){.yc-best-sellers media-with-collection{padding-bottom:4.6rem!important}.yc-best-sellers .product-card__wrapper{display:flex!important;flex-direction:column!important}.yc-best-sellers .product-card__info{order:-1!important;min-height:0!important;height:auto!important;padding:.8rem 1.2rem!important;justify-content:flex-start!important;flex:none!important;background:#f3ede7!important;border-radius:1.2rem 1.2rem 0 0!important}.yc-best-sellers .product-card__image-wrapper{border-radius:0 0 1.2rem 1.2rem!important}.yc-best-sellers .yc-carousel-nav{top:auto!important;bottom:0!important;background:#f3ede7!important;touch-action:pan-y!important;cursor:grab}.yc-best-sellers .yc-carousel-nav__track{touch-action:pan-y}.yc-best-sellers__hint{position:absolute!important;z-index:5;pointer-events:none;white-space:nowrap;font-size:11px;color:#27211d;background:rgba(255,255,255,.78);border:1px solid rgba(39,33,29,.15);border-radius:999px;padding:4px 8px;box-shadow:0 2px 10px #27211d14}.yc-best-sellers__hint--products{right:45px;top:7px}.yc-best-sellers__hint--images{right:12px;top:45%}}@media(min-width:768px){.yc-best-sellers__hint{display:none}}';
      document.head.append(style);
    }
    const track = nav.querySelector('.yc-carousel-nav__track');
    if (!track) return;
    const compactInfo = () => row.querySelectorAll('.product-card__info').forEach(info => {
      if (window.innerWidth < 768) {
        info.style.setProperty('padding', '.8rem 2.65rem', 'important');
        info.style.setProperty('min-height', '0', 'important');
        info.style.setProperty('height', 'auto', 'important');
        info.style.setProperty('flex', '0 0 auto', 'important');
        info.style.setProperty('justify-content', 'flex-start', 'important');
      } else {
        ['padding', 'min-height', 'height', 'flex', 'justify-content'].forEach(key => info.style.removeProperty(key));
      }
    });
    compactInfo();
    window.addEventListener('resize', compactInfo);
    const alignNav = () => {
      if (window.innerWidth >= 768) {
        nav.parentElement?.style.removeProperty('padding-bottom');
        nav.style.removeProperty('top');
        nav.style.removeProperty('bottom');
        return;
      }
      const image = row.querySelector('.product-card__image-wrapper');
      const host = nav.parentElement;
      if (!image || !host) return;
      host.style.paddingBottom = '4.6rem';
      const top = image.getBoundingClientRect().bottom - host.getBoundingClientRect().top;
      nav.style.setProperty('top', Math.round(top) + 'px', 'important');
      nav.style.setProperty('bottom', 'auto', 'important');
    };
    requestAnimationFrame(() => requestAnimationFrame(alignNav));
    window.addEventListener('resize', () => requestAnimationFrame(alignNav));
    window.addEventListener('load', alignNav, { once: true });
    track.setAttribute('role', 'slider');
    track.setAttribute('tabindex', '0');
    track.setAttribute('aria-label', 'Browse Best Sellers products');
    track.setAttribute('aria-valuemin', '0');
    track.setAttribute('aria-valuemax', '100');
    const sync = () => {
      const max = Math.max(0, row.scrollWidth - row.clientWidth);
      track.setAttribute('aria-valuenow', String(max ? Math.round(row.scrollLeft / max * 100) : 0));
    };
    row.addEventListener('scroll', sync, { passive: true });
    window.addEventListener('resize', sync);
    sync();
    const seen = key => { try { return localStorage.getItem(key) === '1'; } catch { return false; } };
    const remember = key => { try { localStorage.setItem(key, '1'); } catch {} };
    const productKey = 'yc-bs-product-hint-v2';
    const productHint = document.createElement('span');
    productHint.className = 'yc-best-sellers__hint yc-best-sellers__hint--products';
    productHint.setAttribute('aria-hidden', 'true');
    productHint.textContent = '‹  More products';
    if (!seen(productKey)) nav.append(productHint);
    const dismissProduct = () => { productHint.remove(); remember(productKey); };
    nav.querySelectorAll('button').forEach(button => button.addEventListener('click', dismissProduct));
    let drag = null;
    let moved = false;
    nav.addEventListener('pointerdown', event => {
      if (event.target.closest('button')) return;
      drag = { id: event.pointerId, x: event.clientX, left: row.scrollLeft };
      moved = false;
      nav.setPointerCapture?.(event.pointerId);
    });
    nav.addEventListener('pointermove', event => {
      if (!drag || drag.id !== event.pointerId) return;
      const dx = event.clientX - drag.x;
      if (Math.abs(dx) > 4) moved = true;
      if (moved) { row.scrollLeft = drag.left - dx; dismissProduct(); }
    });
    const finish = event => { if (drag?.id === event.pointerId) drag = null; };
    nav.addEventListener('pointerup', finish);
    nav.addEventListener('pointercancel', finish);
    track.addEventListener('click', event => {
      if (moved) { moved = false; return; }
      const box = track.getBoundingClientRect();
      const fraction = Math.min(1, Math.max(0, (event.clientX - box.left) / box.width));
      row.scrollTo({ left: fraction * Math.max(0, row.scrollWidth - row.clientWidth), behavior: 'smooth' });
      dismissProduct();
    });
    track.addEventListener('keydown', event => {
      if (event.key !== 'ArrowLeft' && event.key !== 'ArrowRight') return;
      event.preventDefault();
      nav.querySelector(event.key === 'ArrowLeft' ? 'button:first-child' : 'button:last-child')?.click();
      dismissProduct();
    });
    row.querySelectorAll('.product-card__info').forEach(info => {
      // Keep the hint visible during vertical page scrolling; navigation dismisses it.
    });
    const imageKey = 'yc-bs-image-hint-v2';
    if (!seen(imageKey)) {
      const hints = [];
      const dismissImage = () => { hints.forEach(hint => hint.remove()); remember(imageKey); };
      row.querySelectorAll('.product-card__image-wrapper:not(.product-card__image-wrapper--main-only)').forEach(image => {
        const hint = document.createElement('span');
        hint.className = 'yc-best-sellers__hint yc-best-sellers__hint--images';
        hint.setAttribute('aria-hidden', 'true');
        hint.textContent = '‹  More photos';
        image.append(hint);
        hints.push(hint);
        let touchStart = null;
        image.addEventListener('pointerdown', event => { touchStart = { x: event.clientX, y: event.clientY }; }, { passive: true });
        image.addEventListener('pointermove', event => {
          if (touchStart && Math.abs(event.clientX - touchStart.x) > 16 && Math.abs(event.clientX - touchStart.x) > Math.abs(event.clientY - touchStart.y) * 1.2) dismissImage();
        }, { passive: true });
        image.addEventListener('pointerup', () => { touchStart = null; }, { passive: true });
        image.addEventListener('click', dismissImage, { once: true });
      });
    }
  });
  if (document.readyState === 'loading') document.addEventListener('DOMContentLoaded', enhance, { once: true });
  else enhance();
  document.addEventListener('shopify:section:load', enhance);
  /* Mobile-only: image controls remain independent of an endless product rail. */
  (() => {
    const initialize = () => document.querySelectorAll('.yc-best-sellers').forEach((section) => {
      const row = section.querySelector('.media-with-collection__products.swipe-mobile');
      const wrapper = row && row.querySelector('.media-with-collection__products-inner');
      if (!row || !wrapper || section.dataset.ycSeamlessReady) return;
      section.dataset.ycSeamlessReady = 'true';
      section.querySelector('.yc-bs-product-arrows')?.remove();
      if (!document.getElementById('yc-bs-seamless-style')) {
        const style = document.createElement('style');
        style.id = 'yc-bs-seamless-style';
        style.textContent = '@media(max-width:767.98px){.yc-best-sellers .yc-bs-product-arrows{display:none!important}.yc-best-sellers .product-card__info{padding:.8rem 1.2rem!important}.yc-best-sellers .yc-bs-photo-arrow{width:40px;height:40px;border-radius:50%;background:rgba(255,255,255,.38);color:#fff;font-size:30px;text-shadow:0 1px 4px rgba(0,0,0,.78);box-shadow:0 1px 5px rgba(0,0,0,.13);backdrop-filter:blur(3px);-webkit-backdrop-filter:blur(3px)}.yc-best-sellers .yc-bs-photo-arrow--prev{left:8px}.yc-best-sellers .yc-bs-photo-arrow--next{right:8px}}';
        document.head.append(style);
      }
      const realSlides = Array.from(wrapper.children).filter((slide) => slide.classList.contains('swiper-slide') && !slide.dataset.ycLoopClone);
      if (realSlides.length < 3) return;
      let cloneCount = 0, wrapTimer, jumping = false;
      const mobile = () => window.matchMedia('(max-width:767.98px)').matches;
      const step = () => realSlides[1].offsetLeft - realSlides[0].offsetLeft;
      const cloneSlide = (slide) => {
        const clone = slide.cloneNode(true);
        clone.dataset.ycLoopClone = 'true';
        clone.setAttribute('aria-hidden', 'true');
        clone.inert = true;
        clone.querySelectorAll('[id]').forEach((element) => element.removeAttribute('id'));
        return clone;
      };
      const jump = (left) => {
        jumping = true;
        row.style.setProperty('scroll-behavior','auto','important');
        row.style.setProperty('scroll-snap-type','none','important');
        row.scrollLeft = left;
        requestAnimationFrame(() => requestAnimationFrame(() => {
          row.style.removeProperty('scroll-behavior');
          row.style.removeProperty('scroll-snap-type');
          jumping = false;
        }));
      };
      const normalize = () => {
        if (!mobile() || !cloneCount || jumping) return;
        const first = realSlides[0].offsetLeft;
        const last = realSlides[realSlides.length - 1].offsetLeft;
        const period = last - first + step();
        if (row.scrollLeft < first - step()/2) jump(row.scrollLeft + period);
        else if (row.scrollLeft > last + step()/2) jump(row.scrollLeft - period);
      };
      row.addEventListener('scroll', () => { clearTimeout(wrapTimer); wrapTimer = setTimeout(normalize,180); }, {passive:true});
      row.addEventListener('scrollend', normalize, {passive:true});
      const configure = () => {
        if (!mobile()) {
          if (cloneCount) {
            wrapper.querySelectorAll('[data-yc-loop-clone]').forEach((clone) => clone.remove());
            cloneCount = 0;
            row.scrollLeft = 0;
          }
          return;
        }
        if (cloneCount) return;
        cloneCount = Math.min(2, realSlides.length);
        wrapper.prepend(...realSlides.slice(-cloneCount).map(cloneSlide));
        wrapper.append(...realSlides.slice(0,cloneCount).map(cloneSlide));
        requestAnimationFrame(() => jump(realSlides[0].offsetLeft));
      };
      configure();
      window.addEventListener('resize',configure);
    });
    if (document.readyState === 'loading') document.addEventListener('DOMContentLoaded',initialize,{once:true});
    else initialize();
    document.addEventListener('shopify:section:load',() => requestAnimationFrame(initialize));
    /* Best Sellers v3: edge arrows move products; photo swipes stay inside cards. */
    (() => {
      const initRail = () => document.querySelectorAll('.yc-best-sellers').forEach((section) => {
        const row = section.querySelector('.media-with-collection__products.swipe-mobile');
        const wrapper = row && row.querySelector('.media-with-collection__products-inner');
        if (!row || !wrapper || section.dataset.ycRailArrowsReady) return;
        section.dataset.ycRailArrowsReady = 'true';
        if (!document.getElementById('yc-bs-rail-style')) {
          const style = document.createElement('style');
          style.id = 'yc-bs-rail-style';
          style.textContent = '@media(max-width:767.98px){.yc-best-sellers .yc-bs-photo-arrow,.yc-best-sellers .yc-bs-product-arrows{display:none!important}.yc-best-sellers .product-card__wrapper{display:flex!important;flex-direction:column!important}.yc-best-sellers .product-card__info{order:1!important;padding:.8rem 1.2rem!important;border-radius:0 0 1.2rem 1.2rem!important}.yc-best-sellers .product-card__image-wrapper{order:0!important;border-radius:1.2rem 1.2rem 0 0!important}.yc-bs-rail-arrows{position:absolute;left:2px;right:2px;z-index:9;pointer-events:none;display:flex;justify-content:space-between;transform:translateY(-50%)}.yc-bs-rail-arrows button{pointer-events:auto;width:46px;height:56px;padding:0;border:0;background:transparent;color:rgba(255,255,255,.84);display:grid;place-items:center;cursor:pointer}.yc-bs-rail-arrows button::before{content:"";width:17px;height:17px;border-top:3px solid currentColor;border-right:3px solid currentColor;transform:rotate(45deg);filter:drop-shadow(0 1px 2px rgba(0,0,0,.7))}.yc-bs-rail-arrows button:first-child::before{transform:rotate(225deg)}.yc-bs-rail-arrows button:focus-visible{outline:2px solid #fff;outline-offset:-2px}}@media(min-width:768px){.yc-bs-rail-arrows{display:none!important}}';
          document.head.append(style);
        }
        section.querySelector('.yc-bs-product-arrows')?.remove();
        section.querySelectorAll('.yc-bs-photo-arrow').forEach((button) => button.remove());
        const slides = Array.from(wrapper.children).filter((slide) => slide.classList.contains('swiper-slide') && !slide.dataset.ycLoopClone);
        if (slides.length < 2) return;
        const compactText = () => wrapper.querySelectorAll('.product-card__info').forEach((info) => {
          if (window.innerWidth < 768) info.style.setProperty('padding','.8rem 1.2rem','important');
          else info.style.removeProperty('padding');
        });
        requestAnimationFrame(compactText);
        window.addEventListener('resize',compactText);
        const arrows = document.createElement('div');
        arrows.className = 'yc-bs-rail-arrows';
        arrows.innerHTML = '<button type="button" aria-label="Previous product"></button><button type="button" aria-label="Next product"></button>';
        section.append(arrows);
        const position = () => {
          const image = slides[0].querySelector('.product-card__image-wrapper');
          if (image) arrows.style.top = (image.getBoundingClientRect().top-section.getBoundingClientRect().top+image.offsetHeight/2)+'px';
        };
        requestAnimationFrame(() => requestAnimationFrame(position));
        window.addEventListener('resize',position);
        window.addEventListener('load',position,{once:true});
        const move = (direction) => {
          const step = slides[1].offsetLeft-slides[0].offsetLeft;
          if (!step) return;
          const base = slides[0].offsetLeft;
          const current = Math.round((row.scrollLeft-base)/step);
          const index = ((current%slides.length)+slides.length)%slides.length;
          row.scrollTo({left:base+(index+direction)*step,behavior:'smooth'});
        };
        const buttons = arrows.querySelectorAll('button');
        buttons[0].addEventListener('click',() => move(-1));
        buttons[1].addEventListener('click',() => move(1));
        const syncEdgeMedia = () => {
          const clones = Array.from(wrapper.querySelectorAll('[data-yc-loop-clone]'));
          if (clones.length < 4) return;
          clones.forEach((clone,index) => {
            const source = slides[index<2?slides.length-2+index:index-2];
            const sourceTrack = source.querySelector('[data-mobile-product-card-slider]');
            const cloneTrack = clone.querySelector('[data-mobile-product-card-slider]');
            if (!sourceTrack || !cloneTrack || cloneTrack.dataset.ycSynced) return;
            cloneTrack.dataset.ycSynced = 'true';
            const sync = () => {cloneTrack.scrollLeft=sourceTrack.scrollLeft;};
            sourceTrack.addEventListener('scroll',sync,{passive:true});
            sync();
          });
          clones.forEach((clone) => clone.querySelectorAll('img').forEach((image) => {image.loading='eager';}));
        };
        requestAnimationFrame(syncEdgeMedia);
        window.addEventListener('resize',() => requestAnimationFrame(syncEdgeMedia));
      });
      if (document.readyState==='loading') document.addEventListener('DOMContentLoaded',initRail,{once:true});
      else initRail();
      document.addEventListener('shopify:section:load',() => requestAnimationFrame(initRail));
    })();
  })();
})();
